import React, { useEffect, useState } from 'react'
import EditOfficalMail from '../../Components/Model/EditOfficalMail';
import Layout from '../../Components/Layout';
import toast, { Toaster } from "react-hot-toast";
import Skeleton from "react-loading-skeleton";
import { Icon } from "@iconify/react";
import { btnfont, DarkBold, LighterBold, Lightly } from '../../Assets/CSS/Text';
import { Newbtn } from '../../Assets/CSS/Button';
import axios from 'axios';

const GenerateMail = () => {
    const [showModal, setShowModal] = useState(false);
    const [employee, setEmployees] = useState();
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize] = useState(50);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [activeDropdown, setActiveDropdown] = useState(null);
    const handleEditClick = (emp, showEditModal) => {
        // Remove +91 from mobile number if present
        const cleanedMobile =
            emp.mobileNumber?.startsWith("+91")
                ? emp.mobileNumber.slice(3)
                : emp.mobileNumber ?? "";

        // Store cleaned data for editing
        const updatedEmp = {
            ...emp,
            mobileNumber: cleanedMobile,
        };

        setSelectedEmployee(updatedEmp);
        console.log("Employee data (cleaned for editing):", updatedEmp);
        setShowEditModal(true);
    };
    const toggleMenu = (empId) => {
        setActiveDropdown((prev) => (prev === empId ? null : empId));
    };
    const capitalizeWords = (str) =>
        str.replace(/\b\w/g, (char) => char.toUpperCase());
    const handleCloseModal = () => {
        setShowEditModal(false);
    };

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const handleOpenModal = () => {
        setShowModal(true);
    };
    const featchEmployeeData = async () => {
        setLoading(true); // Start loading before fetching
        try {
            const token = localStorage.getItem("token"); // Or however you're storing it
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps`,

                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        page: pageNumber,
                        size: pageSize,
                    },
                }
            );

            console.log("Employee API response:", response.data);
            setEmployees(response.data.content);
        } catch (error) {
            console.error("Error fetching employee data:", error);
        } finally {
            setLoading(false); // Stop loading after fetch
        }
    };

    useEffect(() => {
        featchEmployeeData();
    }, []);

    const filteredEmployees = (employee || [])
        .filter((emp) => emp.status?.toUpperCase() === "PENDING_IT_SETUP")
        .filter((emp) => {
            const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""} ${emp.lastName ?? ""}`.trim();
            return fullName.toLowerCase().includes(searchQuery);
        });

    const handleSearchChange = (e) =>
        setSearchQuery(e.target.value.toLowerCase());
    return (
        <Layout>
            <Toaster position="top-right" reverseOrder={false} />
            <div className="backgound-main-content">
                <div className="timesheet-header">
                    {isMobile ? (
                        <div className="">
                            <div className="header-mob-title">
                                <h2>Generate Mail List</h2>

                            </div>

                            <div className="timesheet-controls">
                                <div className="search-bar">
                                    <input
                                        type="text"
                                        className="border-none"
                                        placeholder="Search employee name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon
                                        icon="iconamoon:search"
                                        width="20"
                                        height="20"
                                        color="rgba(0, 175, 239, 1)"
                                    />
                                </div>
                            </div>
                            <div className="employee-card-list">
                                {loading
                                    ? // 🔹 Show 6 skeleton cards while loading
                                    Array.from({ length: 6 }).map((_, index) => (
                                        <div className="employee-card" key={index}>
                                            <div className="emp-head">
                                                <p className="emp-id"><Skeleton width={50} height={16} /></p>
                                                <div className="card-actions-menu">
                                                    <Skeleton circle width={20} height={20} />
                                                </div>
                                            </div>
                                            <div className="card-main">
                                                <Skeleton circle width={60} height={60} className="card-avatar" />
                                                <div className="card-info">
                                                    <h4 className="emp-name"><Skeleton width={120} /></h4>
                                                    <p className="emp-email"><Skeleton width={160} /></p>
                                                    <p className="emp-contact"><Skeleton width={100} /></p>
                                                    <p className="emp-department"><Skeleton width={80} /></p>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                    :
                                    filteredEmployees.map((emp, index) => {
                                        const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""
                                            } ${emp.lastName ?? ""}`.trim();
                                        const avatar = emp.profilePhotoUrl || "";
                                        const empId = emp.empId ?? "-";
                                        const officeEmail = emp.officeEmail ?? "-";
                                        const mobile = emp.mobileNumber ?? "-";
                                        const department = emp.departmentName ?? "-";

                                        return (
                                            <div className="employee-card" key={index}>
                                                <div className="emp-head">
                                                    <p className="emp-id">{empId}</p>
                                                    <div className="card-actions-menu">
                                                        <Icon
                                                            icon="ph:dots-three-vertical-bold"
                                                            className="menu-toggle"
                                                            onClick={() => toggleMenu(emp.empId)}
                                                        />
                                                        {activeDropdown === emp.empId && (
                                                            <div className="menu-dropdown">
                                                                {/* <span
                                                                    onClick={() => handleViewEmployee(emp.empId)}
                                                                >
                                                                    👁️ View
                                                                </span> */}
                                                                <span onClick={() => handleEditClick(emp)}>
                                                                    ✏️ Edit
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="card-main">
                                                    {avatar ? (
                                                        <img
                                                            src={avatar}
                                                            alt={fullName}
                                                            className="card-avatar"
                                                        />
                                                    ) : (
                                                        <div className="card-avatar placeholder">
                                                            <Icon icon="proicons:person" className="fs-5" />
                                                        </div>
                                                    )}
                                                    <div className="card-info">
                                                        <h4 className="emp-name">
                                                            {capitalizeWords(fullName)}
                                                        </h4>
                                                        <p className="emp-email">{officeEmail}</p>
                                                        <p className="emp-contact">{mobile}</p>
                                                        <p className="emp-department">
                                                            {capitalizeWords(department)}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    ) : (
                        <div className="">
                            <div className="header-title">
                                <h2>Generate Mail List</h2>
                            </div>

                            <div className="timesheet-controls">
                                <div className="search-bar">
                                    <input
                                        type="text"
                                        className="border-none"
                                        placeholder="Search employee name"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                    <Icon
                                        icon="iconamoon:search"
                                        width="20"
                                        height="20"
                                        color="rgba(0, 175, 239, 1)"
                                    />
                                </div>
                            </div>
                            <div className="timesheet-table">
                                <table className="employee-table">
                                    <thead>
                                        <tr>
                                            <th style={LighterBold}>ID</th>
                                            <th style={LighterBold}>Employee Name</th>
                                            <th style={LighterBold}>Email Id</th>
                                            <th style={LighterBold}>Contact Number</th>
                                            <th style={LighterBold}>Department</th>
                                            <th style={LighterBold}>Actions</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {loading
                                            ? // 🔹 Skeleton rows while loading
                                            Array.from({ length: 5 }).map((_, index) => (
                                                <tr key={index}>
                                                    <td><Skeleton width={40} /></td>
                                                    <td className="employee-info d-flex align-items-center gap-2">
                                                        <Skeleton circle width={36} height={36} />
                                                        <Skeleton width={100} />
                                                    </td>
                                                    <td><Skeleton width={120} /></td>
                                                    <td><Skeleton width={100} /></td>
                                                    <td><Skeleton width={80} /></td>
                                                    <td className="d-flex gap-3">
                                                        <Skeleton width={20} height={20} circle />
                                                        <Skeleton width={20} height={20} circle />
                                                    </td>
                                                </tr>
                                            ))
                                            :
                                            filteredEmployees.map((emp, index) => {
                                                const fullName = `${emp.firstName ?? ""} ${emp.middleName ?? ""
                                                    } ${emp.lastName ?? ""}`.trim();
                                                const avatar = emp.profilePhotoUrl || ""; // Show placeholder if null
                                                const officeEmail = emp.officeEmail ?? "-";
                                                const personalEmail = emp.personalEmail ?? "-";
                                                const mobile = emp.mobileNumber ?? "-";
                                                const department = emp.departmentName ?? "-";
                                                const empId = emp.empId ?? " - ";

                                                return (
                                                    <tr key={index}>
                                                        <td style={Lightly}>{empId}</td>
                                                        <td className="employee-info">
                                                            {avatar ? (
                                                                <img
                                                                    src={avatar}
                                                                    alt={fullName}
                                                                    className="rounded-circle"
                                                                    style={{
                                                                        width: "36px",
                                                                        height: "36px",
                                                                        objectFit: "cover",
                                                                    }}
                                                                />
                                                            ) : (
                                                                <div
                                                                    className="rounded-circle d-flex justify-content-center align-items-center"
                                                                    style={{
                                                                        width: "36px",
                                                                        height: "36px",
                                                                        fontSize: "12px",
                                                                        color: "#999",
                                                                        backgroundColor: "#F0F0F0",
                                                                        border: "1px solid #F0F0F0 ",
                                                                    }}
                                                                >
                                                                    <Icon
                                                                        icon="proicons:person"
                                                                        className="fs-5 "
                                                                        style={{}}
                                                                    />
                                                                </div>
                                                            )}
                                                            <span style={DarkBold}>
                                                                {capitalizeWords(fullName)}
                                                            </span>
                                                        </td>
                                                        <td style={Lightly}>{officeEmail}</td>
                                                        <td style={Lightly}>{mobile}</td>
                                                        <td style={Lightly}>{capitalizeWords(department)}</td>
                                                        {/* <td className="d-flex gap-3">
             <Icon icon="hugeicons:view" className="eye" />
             <Icon icon="mdi:edit" className="pen" />
             <Icon icon="material-symbols:delete-outline" color="red" />
           </td> */}
                                                        <td className="d-flex gap-3">
                                                            {/* <Icon
                                                                icon="hugeicons:view"
                                                                style={{
                                                                    color: "#00AFEF",
                                                                    fontSize: "18px",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => handleViewEmployee(emp.empId)}
                                                            /> */}
                                                            <Icon
                                                                icon="mdi:edit"
                                                                style={{
                                                                    color: "#00AFEF",
                                                                    fontSize: "18px",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={() => handleEditClick(emp)}
                                                            />
                                                            {/* <Icon
                             icon="material-symbols:delete-outline"
                             style={{
                               color: "#DD0000",
                               fontSize: "18px",
                               cursor: "pointer",
                             }}
                           /> */}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
                {/* Show Modal */}

                {/* {showEditModal && selectedEmployee && (
                    <EditOfficalMail
                        onClose={handleCloseModal}
                        onEmployeeAdded={() => {
                            featchEmployeeData(); // Refresh data after new employee is added
                            setShowModal(false); // Close modal
                        }}
                    />
                )} */}
                {showEditModal && selectedEmployee && (
                    <EditOfficalMail
                        employeeId={selectedEmployee.empId}   // ✅ ADD THIS
                        onClose={handleCloseModal}
                        onSuccess={featchEmployeeData}        // also fix prop name
                    />
                )}

            </div>
        </Layout>
    );
}

export default GenerateMail